module.exports = __webpack_public_path__ + "5d2e2d35874e3e038eb48d318f2c3548.woff2";